import React from "react";

const SearchCloseIcon = () => {
  return (
    <svg
      id="Actions_Navigation_close_24"
      data-name="Actions / Navigation / close / 24"
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
    >
      <path
        id="Fill"
        d="M14,1.225,12.775,0,7,5.775,1.225,0,0,1.225,5.775,7,0,12.775,1.225,14,7,8.225,12.775,14,14,12.775,8.225,7Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default SearchCloseIcon;
